module.exports = __webpack_public_path__ + "static/media/virtual-maps-thumb.eded03a7.jpg";